import React from 'react';

import IconButton from '~/components/core/Atomic/Buttons/IconButton';
import Text from '~/components/core/TextComponents/Text';
import { DaReinspectionIcon, SortIcon } from '~/components/icons';
import colors from '~/theme/tailwind/colors';

interface FeedControlsProps {
  /** What the count next to the controls says. Each feed decides which entries it counts. */
  count: number;
  isReversed: boolean;
  onToggleOrder: () => void;
  highlightsOnly: boolean;
  onToggleHighlights: () => void;
}

/** The right side of a notifications feed's header: its count, then order and highlights toggles. */
const FeedControls: React.FC<FeedControlsProps> = ({
  count,
  isReversed,
  onToggleOrder,
  highlightsOnly,
  onToggleHighlights,
}) => (
  <div className="flex items-center gap-8">
    <Text variant={Text.VARIANTS.XS} colorVariant={Text.COLOR_VARIANTS.SECONDARY}>
      {`${count} ${count === 1 ? 'notification' : 'notifications'}`}
    </Text>
    <IconButton
      size="small"
      onClick={onToggleOrder}
      title={isReversed ? 'Show oldest first' : 'Show newest first'}
      aria-label={isReversed ? 'Show oldest first' : 'Show newest first'}
    >
      <SortIcon
        size={16}
        iconColor={isReversed ? colors.blue[600] : colors.grey[700]}
        className={isReversed ? 'rotate-180 transition-transform' : 'transition-transform'}
      />
    </IconButton>
    <IconButton
      size="small"
      onClick={onToggleHighlights}
      title={highlightsOnly ? 'Show all notifications' : 'Show highlights only'}
      aria-label={highlightsOnly ? 'Show all notifications' : 'Show highlights only'}
    >
      <DaReinspectionIcon size={16} iconColor={highlightsOnly ? colors.blue[600] : colors.grey[700]} />
    </IconButton>
  </div>
);

export default FeedControls;
